import { Textarea } from "@chakra-ui/react";
import { UseFormRegisterReturn } from "react-hook-form";

import { FieldWrapper, FieldWrapperPassThroughProps } from "./FieldWrapper";

type TextFieldProps = FieldWrapperPassThroughProps & {
  registration: Partial<UseFormRegisterReturn>;
};

export const TextField = (props: TextFieldProps) => {
  const { label, registration, error, chakraOptions, isRequired } = props;

  return (
    <FieldWrapper
      label={label}
      error={error}
      isRequired={isRequired}
      chakraOptions={chakraOptions}
    >
      <Textarea {...registration} maxWidth="50rem" backgroundColor="white" />
    </FieldWrapper>
  );
};
